<template>
  <multiselect
    v-model="selectedItems"
    ref="combo-multiple"
    :options="items"
    :multiple="true"
    :close-on-select="false"
    :clear-on-select="false"
    :preserve-search="true"
    :placeholder="placeholder"
    :label="propertyName"
    :track-by="propertyName"
    :preselect-first="false"
    :showNoResults="false"
    :showNoOptions ="false"
    selectLabel
    deselectLabel
    @input="changed()"
  >
    <label class="typo__label">Tagging</label>
  </multiselect>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: {
    items: Array,
    // selectedItems: Array,
    currentItems: Array,
    propertyName: String,
    propertyID: String,
    placeholder: String
  },
  data(){
      return{
          selectedItems: this.currentItems
      }
  },
  methods: {
    changed() {
      this.$emit("input", this.selectedItems);
    },
    cargar() {
      this.selectedItems = [];
      for (let i = 0; i < this.items.length; i++) {
        for (let j = 0; j < this.currentItems.length; j++) {
          if (this.items[i][this.propertyID] == this.currentItems[j]) {
            this.selectedItems.push(this.items[i]);
          }
        }
      }
      
      this.$emit("input", this.selectedItems);
    }
  },
  watch: {
    currentItems: function(newValue, oldValue) {
        this.cargar();
    },
    items: function(newValue, oldValue) {
        this.cargar();
    }
  }
};
</script>